// CI-958 — who a series is live to. Must match series.audience in cinema-admin-service.
export const SERIES_AUDIENCE_OPTIONS = [
    { value: 'ALL', label: 'All users' },
    { value: 'SPECIFIC', label: 'Specific users' },
];

export const formatSeriesAudience = (series) => {
    if (series?.audience !== 'SPECIFIC') return 'All users';
    const names = (series.audience_segments || []).map(s => s.name).filter(Boolean);
    return names.length ? `Specific users: ${names.join(', ')}` : 'Specific users (no segment)';
};

// Same rules as the backend: split pasted / CSV text on commas, semicolons,
// whitespace and newlines, strip quotes, de-duplicate keeping first-seen order.
export const parseUserIds = (text) => [...new Set(
    String(text || '').split(/[\s,;]+/)
        .map(part => part.trim().replace(/^["']+|["']+$/g, '').trim())
        .filter(Boolean),
)];
